export default __webpack_public_path__ + "static/media/logo_lib.da77e04a.png";